export default "__VITE_ASSET__CrB2w40M__"